////////////////////ootb implementation//////////////////////
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { environment } from '../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model'
@Component({
    selector: 'app-homepage-image-section5',
    templateUrl: './homepage-image-section5.component.html',
    styleUrl: './homepage-image-section5.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageImageSection5Component implements OnChanges {
  @Input() componentData: CustomCmsVideoComponent;
  data$: Observable<string>;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnChanges(): void {
    this.data$ = of(this.componentData).pipe(
      map(data => environment.siteUrls.getBackofficeUrl + data.media.url.split('medias/')[1])
    );
  }
}
////old Implimentation////////////////////////////////
// import { ChangeDetectionStrategy, Component } from '@angular/core';
// import { CmsComponentData } from '@spartacus/storefront';
// import { environment } from '../../../../../environments/environment';

// @Component({
//   selector: 'app-homepage-image-section5',
//   templateUrl: './homepage-image-section5.component.html',
//   styleUrl: './homepage-image-section5.component.scss',
//   changeDetection: ChangeDetectionStrategy.OnPush
// })
// export class HomepageImageSection5Component {

//   public componentData: any;
//   imageUrl: string;

//   constructor(public component: CmsComponentData<any>) { }

//   ngOnInit(): void {
//     this.component.data$.subscribe((data) => {
//       this.componentData = data;
//       this.imageUrl = environment.siteUrls.getBackofficeUrl + data?.media?.url?.split('medias/')[1];
//     });
//   }
// }
